// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "org.thorwallet",
    name: "THORWallet",
    homepage: "https://www.thorwallet.org/",
    image_id: "45165bea-fdae-454e-7caa-31681f255200",
    app: {
        browser: null,
        ios: "https://apps.apple.com/ch/app/thorwallet-defi-wallet/id1592064324",
        android: "https://play.google.com/store/apps/details?id=defisuisse.thorwallet",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "thorwallet://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map